import { DropdownOptions } from '../../../components/form_v2/types';
import { IOmekaResp } from './RegistrationOrganisation';

export interface initialValuesForeas {
    country: string;
    orgIdentifierEnAbbreviation: string;
    organisationsName: string;
  }

export const initialValues: initialValuesForeas = {
  country: '',
  orgIdentifierEnAbbreviation: '',
  organisationsName: '',
};

export const initialValuesEditForeas = ({
  id,
  organisationsUniqueCode,
  orgIdentifierCountryId,
  organisationsName,
  organisationsAbbreviation,
  organisationsEnNameEn,
  orgIdentifierEnAbbreviation,
  organisationsEmail,
  organisationsWebsite,
  organisationsTelephone,
  orgIdentifierFullAddress,
  organisationsCountry,
  orgIdentifierComments,
  orgIdentifierCommentsEn,
}: IOmekaResp | Record<string, never>) => {
  return {
    id,
    organisationsUniqueCode,
    orgIdentifierCountryId,
    organisationsName,
    organisationsAbbreviation,
    organisationsEnNameEn,
    orgIdentifierEnAbbreviation,
    organisationsEmail,
    organisationsWebsite,
    organisationsTelephone,
    orgIdentifierFullAddress,
    organisationsCountry,
    orgIdentifierComments,
    orgIdentifierCommentsEn,
  };
};

export const initialValuesEditCollection = ({
  id,
  collectionsUniqueCode,
  collectionsIdentifierUniqueCode,
  collectionsTitle,
  collectionsEnTitle,
  collectionsDescription,
  collectionEnDescription,
  collectionInternalFlag,
  collectionFeaturedFlag,
  organisationsUniqueCode,
  collectionsComments,
  collectionsCommentsEn,
  collectionsRelateOrganisation
}: any) => {
  return {
    id,
    collectionsUniqueCode,
    collectionsIdentifierUniqueCode,
    collectionsTitle,
    collectionsEnTitle,
    collectionsDescription,
    collectionEnDescription,
    collectionInternalFlag,
    collectionFeaturedFlag,
    organisationsUniqueCode,
    collectionsComments,
    collectionsCommentsEn,
    collectionsRelateOrganisation
  };
};

export const initialValuesEditDocument = ({
  id,
  documentsUniqueCode,
  documentIdentifier,
  documentsID,
  documentsTitle,
  documentsRelationOrganisation,
  documentsRelationCollection,
  documentsEnTitle,
  documentsType,
  documentsDescription,
  documentsEnDescription,
  documentsDateCreation,
  documentsFormat,
  documentsDuration,
  documentsColor,
  documentsSound,
  documentsTechnical,
  documentsSize,
  documentsHeight,
  documentsWidth,
  documentsFrameRate,
  documentsAspectRatio,
  documentsCopyright,
  documentsLicence,
  documentsComments,
  documentsEnComments,
  documentsVimeoYtTitle,
  documentsVimeoYtUrl,
  documentsAttachedMediaImages,
  documentsAttachedMediaFiles,
  documentsRelationProject
}: any) => {
  return {
    id,
    documentsUniqueCode,
    documentIdentifier,
    documentsID,
    documentsTitle,
    documentsRelationOrganisation,
    documentsRelationCollection,
    documentsEnTitle,
    documentsType,
    documentsDescription,
    documentsEnDescription,
    documentsDateCreation,
    documentsFormat,
    documentsDuration,
    documentsColor,
    documentsSound,
    documentsTechnical,
    documentsSize,
    documentsHeight,
    documentsWidth,
    documentsFrameRate,
    documentsAspectRatio,
    documentsCopyright,
    documentsLicence,
    documentsComments,
    documentsEnComments,
    documentsVimeoYtTitle,
    documentsVimeoYtUrl,
    documentsAttachedMediaImages,
    documentsAttachedMediaFiles,
    documentsRelationProject
  };
};
export interface initialValuesCollection {
    collectionsTitle: string;
    orgIdentifierCountryId: string;
}

export const initialValuesCollection: initialValuesCollection = {
  collectionsTitle: '',
  orgIdentifierCountryId: ''
};

export interface initialValuesDocument {
  organisationsIdentifier: string;
  collectionsUniqueCode: string;
  documentsTitle: string;
}
export const initialValuesDocument: initialValuesDocument = {
  organisationsIdentifier: '',
  collectionsUniqueCode: '',
  documentsTitle: ''
};

export interface initialValuesProject {
  projectTitle: string;
  countryId: string;
}
export const initialValuesProject: initialValuesProject = {
  projectTitle: '',
  countryId: '',
};

export const initialValuesEditErgo = ({
  projectIdentifier,  
  projectUniqueCode, 
  projectTitle,  
  projectEnTitle, 
  projectAlternativeTitle, 
  projectRelationWithTypeOfProject, 
  projectRelationWithLocation,  
  projectRelationWithDocument, 
  projectBelongsTo,  
  projectLanguage,  
  projectDuration,  
  projectCreativeCommons, 
  projectKeywords, 
  projectEducational,  
  projectYear,  
  projectCountry,  
  projectCopyright,  
  projectComments,  
  projectOrganisation,  
  projectTrainer,  
  projectLab,  
  projectCreationTeam,  
  projectAward,  
  projectDisplayRegion,
  projectDescription,                  
  projectEnDescription,                  
  projectFormat,
  projectColor,
  projectSound,
  projectSize,
  projectHeight,
  projectWidth,
  projectFrameRate,
  projectAspectRatio,
  projectEnComments,
  projectEduInstitution,
  projectEduLevel,
  projectNumberPlayers,
  projectsMutualGoal,
  projectConnectorWithContributor,
  projectOtherLocations,
  id
}: any) => {
  return {
    id,
    projectIdentifier,
    projectUniqueCode, 
    projectTitle,  
    projectEnTitle, 
    projectAlternativeTitle, 
    projectRelationWithTypeOfProject, 
    projectRelationWithLocation,  
    projectRelationWithDocument, 
    projectBelongsTo,  
    projectLanguage,  
    projectDuration,  
    projectCreativeCommons, 
    projectKeywords, 
    projectEducational,  
    projectYear,  
    projectCountry,  
    projectCopyright,  
    projectComments,  
    projectOrganisation,  
    projectTrainer,  
    projectLab,  
    projectCreationTeam,  
    projectAward,  
    projectDisplayRegion,  
    projectDescription,                  
    projectEnDescription,                  
    projectFormat,
    projectColor,
    projectSound,
    projectSize,
    projectHeight,
    projectWidth,
    projectFrameRate,
    projectAspectRatio,
    projectEnComments,
    projectEduInstitution,
    projectEduLevel,
    projectNumberPlayers,
    projectsMutualGoal,
    projectConnectorWithContributor,
    projectOtherLocations
  };
};

export const countryOptions: DropdownOptions[] = [
  { key: 'GR', value: 'GR'},
  { key: 'CYP', value: 'CYP'},
  { key: 'AT', value: 'AT'},
  { key: 'AL', value: 'AL'},
  { key: 'BE', value: 'BE'},
  { key: 'BG', value: 'BG'},
  { key: 'FR', value: 'FR'},
  { key: 'DE', value: 'DE'},
  { key: 'GE', value: 'GE'},
  { key: 'DK', value: 'DK'},
  { key: 'MKD', value: 'MKD'},
  { key: 'CH', value: 'CH'},
  { key: 'EST', value: 'EST'},
  { key: 'GB', value: 'GB'},
  { key: 'ES', value: 'ES'},
  { key: 'IL', value: 'IL'},
  { key: 'IT', value: 'IT'},
  { key: 'HR', value: 'HR'},
  { key: 'BY', value: 'BY'},
  { key: 'LT', value: 'LT'},
  { key: 'LI', value: 'LI'},
  { key: 'LU', value: 'LU'},
  { key: 'ME', value: 'ME'},
  { key: 'NL', value: 'NL'},
  { key: 'UA', value: 'UA'},
  { key: 'PT', value: 'PT'},
  { key: 'RO', value: 'RO'},
  { key: 'RU', value: 'RU'},
  { key: 'SK', value: 'SK'},
  { key: 'SE', value: 'SE'},
  { key: 'SY', value: 'SY'},
  { key: 'CZ', value: 'CZ'},
  { key: 'TR', value: 'TR'}];
